import type { Page } from '../../types';

const beforeYouStart: Page[] = [
  {
    pageType: 'question',
    title: 'Before you start',
    name: 'before-you-start',
    description:
      'Thank you for choosing to nominate a Cabinet Office Digital colleague for a reward. Cabinet Office Digital staff often go above and beyond what is expected of them in their current role, and it is important that they are rewarded and recognised for this.<br /><br />' +
      'Recognition is at the heart of the Cabinet Office. Whether it is a high-profile project or the steady, vital work of the engine room, saying thank you helps us build a culture of respect, trust and collaboration.<br /><br />' +
      'Nominations will be reviewed by the relevant function reward and recognition panel. If approved, the nominee will receive their award shortly after the panel meeting is held.<br /><br />' +
      'More information and guidance on Reward & Recognition can be found on the <a target=_blank href=https://sites.google.com/cabinetoffice.gov.uk/digital-staff-pages/reward-and-recognition>Community Hub</a> and the Intranet.<br /><br />' +
      "As you progress through the form, your progress will be saved. You can leave this form and revisit it at any time. Unfinished forms will be deleted after 90 days of inactivity. Once you submit a form, you can visit the 'My Forms' section of this website to view an archived copy. Submitted forms will be kept for 2 years from the date of submission.<br /><br />",
    questions: [
      {
        questionType: 'textInput',
        title: 'Email for person submitting this form',
        hint: 'Please enter your email address.',
        name: 'submitter-email',
        userEmail: true,
        rules: {
          required: true,
          email: true,
        },
      },
    ],
  },
];

export default beforeYouStart;
